import React from "react"
import { useLocation, Link } from "react-router-dom"
import "./Back.css"

/*
  Back Component
  Props:
    title: main heading text
    subtitle?: small tagline shown under title
    bg?: background image url (public path or imported)
    hideBreadcrumb?: boolean to hide breadcrumb trail
*/
const Back = ({ title, subtitle, bg, hideBreadcrumb = false }) => {
  const location = useLocation()

  // Build breadcrumb segments from current path
  const segments = location.pathname
    .split("/")
    .filter(Boolean)
    .map((seg, idx, arr) => {
      const path = "/" + arr.slice(0, idx + 1).join("/")
      return { label: decodeURIComponent(seg.replace(/[-_]/g, " ")), path }
    })

  return (
    <div
      className="back-hero-wrapper"
      style={bg ? { backgroundImage: `url(${bg})` } : undefined}
    >
        <h1 className="back-title">{title}</h1>
        {subtitle && <p className="back-subtitle">{subtitle}</p>}

      <div className='margin'></div>
    </div>
  )
}

export default Back
